import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';

/**
 * LessonBanner — dismissible pre-lesson materials banner.
 * Shown above Step 1 only. Persists dismissal in localStorage.
 */
const LessonBanner = ({ lessonId, bannerText, phaseKey }) => {
  const storageKey = `br_banner_dismissed_${phaseKey}_${lessonId}`;
  const [dismissed, setDismissed] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(storageKey)) setDismissed(true);
    } catch {}
  }, [storageKey]);

  if (dismissed || !bannerText) return null;

  const handleDismiss = () => {
    setHiding(true);
    try { localStorage.setItem(storageKey, '1'); } catch {}
    setTimeout(() => setDismissed(true), 300);
  };

  return (
    <div
      className={`mb-4 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 flex items-center justify-between gap-3 transition-all duration-300 ${hiding ? 'max-h-0 opacity-0 overflow-hidden mb-0 py-0 border-0' : 'max-h-24 opacity-100'}`}
    >
      <p className="text-sm text-amber-800 leading-snug">
        <span className="mr-1.5">📋</span>
        {bannerText}
      </p>
      <button
        onClick={handleDismiss}
        className="flex-shrink-0 flex items-center gap-1 text-xs font-semibold text-amber-600 hover:text-amber-800 bg-amber-100 hover:bg-amber-200 rounded-lg px-3 py-1.5 transition-colors"
      >
        Got it
        <Check className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default LessonBanner;
